<template>
  <el-card
    header="Tracking"
    shadow="never"
  >
    <div
      slot="header"
      class="clearfix"
    >
      <span>
        Tracking
      </span>
      <el-dropdown style="float: right; cursor: pointer;">
        <span class="el-dropdown-link">
          Actions <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="createTrackingEvent">
            <i class="el-icon-plus" />Add Event
          </el-dropdown-item>
          <el-dropdown-item @click.native="createTrackingSubscription">
            <i class="el-icon-message" />Subscriptions
          </el-dropdown-item>
          <el-dropdown-item @click.native="viewNotificationEvents">
            <i class="el-icon-bell" />Notification Events
          </el-dropdown-item>
          <el-dropdown-item @click.native="openTrackMyParcel">
            <i class="el-icon-view" />Track My Parcel
          </el-dropdown-item>
          <el-dropdown-item
            v-if="consignment.carrier.carrier_tracking_link"
            @click.native="openCarrierTracking"
          >
            <i class="el-icon-connection" />Carrier Tracking Page
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <template>
      <el-col :md="24">
        <el-row>
          <el-alert
            v-if="latestEvent"
            type="success"
            show-icon
            :title="latestEvent.created_at"
            :description="getLatestTracking() ? getLatestTracking().created_at : ''"
            :closable="false"
          />
        </el-row>
      </el-col>
    </template>
    <el-row>
      <TrackingTable :consignment="consignment" />
    </el-row>
  </el-card>
</template>
<script>
import TrackingTable from './Table'
import AddEventDialog from './AddEventDialog'
import SubscriptionDialog from './SubscriptionDialog'
import NotifcationEventDialog from './NotifcationEventDialog'

import Vue from 'vue'

export default {
  components: {
    TrackingTable
  },
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      latestEvent: null,
      addEventDialogVisible: false,
      notificationEventDialogVisible: false
    }
  },
  methods: {
    openTrackMyParcel () {
      window.open('https://trackmyparcel.com.au/' + this.consignment.con_full)
    },
    openCarrierTracking () {
      window.open(this.consignment.carrier.carrier_tracking_link.replace('{con}', this.consignment.con_full))
    },
    getLatestTracking () {
      if (this.consignment.trackings.length) {
        this.latestEvent = this.consignment.trackings.slice(-1)
      }
    },
    createTrackingEvent () {
      const AddEventDialogClass = Vue.extend(AddEventDialog)

      this.addEventInstance = new AddEventDialogClass({
        propsData: {
          consignment: this.consignment
        }
      })

      this
        .addEventInstance
        .$on('destroy', () => {
          this.addEventDialogVisible = false
        })

      this
        .addEventInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.addEventInstance.$el)

      this.addEventDialogVisible = true
    },
    createTrackingSubscription () {
      const SubscriptionDialogClass = Vue.extend(SubscriptionDialog)

      this.subscriptionInstance = new SubscriptionDialogClass({
        propsData: {
          consignment: this.consignment
        }
      })

      this
        .subscriptionInstance
        .$on('destroy', () => {
          this.subscriptionDialogVisible = false
          this.consignment.reload()
        })

      this
        .subscriptionInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.subscriptionInstance.$el)

      this.subscriptionDialogVisible = true
    },
    viewNotificationEvents () {
      const NotifcationEventDialogClass = Vue.extend(NotifcationEventDialog)

      this.notificationEventDialogInstance = new NotifcationEventDialogClass({
        propsData: {
          resource: this.consignment
        }
      })

      this
        .notificationEventDialogInstance
        .$on('destroy', () => {
          this.notificationEventDialogVisible = false
          this.notificationEventDialogInstance.$destroy()
          this.notificationEventDialogInstance.$el.remove()
          this.notificationEventDialogInstance = undefined
        })

      this
        .notificationEventDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.notificationEventDialogInstance.$el)

      this.notificationEventDialogVisible = true
    }
  }
}
</script>
